<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-row align-v="center">
          <b-col class="mr-auto">
            <h5 class="mb-0">Паспорт объекта</h5>
          </b-col>
          <b-col cols="auto">
            <b-button v-if="canEditLocations()" size="sm" variant="success" @click="onAdd" :disabled="isBusy || isDisabled">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Добавить
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card no-body>
        <b-row no-gutters>
          <b-col
            cols="12"
            xl="4"
            v-for="(item, index) in items"
            :key="item.id"
          >
            <b-card
              no-body
              class="adaptive-card h-100"
              @click="onEdit(index)"
            >
              <b-card-body class="d-flex flex-column">
                <b-row class="mb-2">
                  <b-col>
                    <h5 class="mb-0">{{ item.title }}</h5>
                  </b-col>
                </b-row>
                <b-row class="mb-1 flex-grow-1 text-small text-muted text-clamp">
                  <b-col>
                    {{ item.description || 'Нет описания' }}
                  </b-col>
                </b-row>
                <b-row class="px-3">
                  <div v-if="item.isLoadingFiles" class="media-preview-row d-flex align-items-center justify-content-center bg-light rounded text-muted small">
                    <b-spinner small class="mr-2" variant="success"/>
                    <small>Загрузка файлов...</small>
                  </div>

                  <div class="media-preview-row d-flex" v-else-if="item.files.length > 0">
                    <template v-for="(file, index) in item.files">
                      <div
                        v-if="index < 3"
                        :key="index"
                        class="media-preview-col mr-1 position-relative border"
                      >
                        <div v-if="!file.hasError">
                          <video v-if="file.type.startsWith('video')" :src="file.url" class="media-obj" preload="metadata" @error="$set(file, 'hasError', true)"/>
                          <img v-else :src="file.url" class="media-obj" alt="img" @error="$set(file, 'hasError', true)"/>
                        </div>

                        <div v-else class="h-100 w-100 d-flex flex-column align-items-center justify-content-center text-muted">
                          <font-awesome-icon icon="exclamation-circle" class="mb-1 text-danger"/>
                          <small>Ошибка загрузки</small>
                        </div>

                        <div v-if="index === 2 && item.files.length > 3" class="more-overlay">
                          +{{ item.files.length - 3 }}
                        </div>
                      </div>
                    </template>
                  </div>

                  <div v-else class="media-preview-row d-flex align-items-center justify-content-center bg-light rounded text-muted small">
                    <small>Нет файлов</small>
                  </div>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="items.length === 0" class="p-5 text-center text-muted bg-light w-100">
          <b-card-body>
            <div class="mb-0">
              <font-awesome-icon icon="times-circle" class="mr-1"/>
              Файлы отсутствуют
            </div>
          </b-card-body>
        </div>
      </b-card>

      <b-modal
        id="modal-location-passport"
        ref="modal_location_passport"
        size="xl"
        :title='locationPassport.id === 0 ? "Новая запись" : `Редактирование паспорта "${locationPassport.title}".`'
        centered
        scrollable
        :ok-only="true"
        no-close-on-backdrop
        no-close-on-esc
        v-model="showModalPassportFiles"
        @ok.prevent="handleSubmit()"
        @cancel="hideModal()"
        @hidden="cleanUpModal"
      >
        <b-row>
          <b-col>
            <b-form-group
              label="Заголовок"
            >
              <b-form-input
                v-model="locationPassport.title"
                :disabled="isDisabled || !canEditLocations()"
                size="sm"
                type="text"
                placeholder="Введите заголовок"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Описание"
            >
              <b-form-textarea
                v-model="locationPassport.description"
                :disabled="isDisabled || !canEditLocations()"
                placeholder="Нет описания"
                size="sm"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Файлы">
              <b-form-file
                v-if="canEditLocations()"
                ref="passportFileInput"
                multiple
                :disabled="isDisabled"
                size="sm"
                placeholder="Файлы не выбраны"
                browse-text="Выбрать"
                accept="image/*,video/*"
                @change="handleUpload"
              >
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" class="mb-2 position-relative" v-for="(file, index) in locationPassport.files" :key="index">
            <div class="modal-media-size border rounded overflow-hidden position-relative">
              <div class="modal-media-position" @click="!file.hasError ? openMediaView(file) : null">
                <div v-if="!file.hasError">
                  <video v-if="file.type.startsWith('video')" :src="file.url" class="media-obj" preload="metadata"  @error="$set(file, 'hasError', true)"/>
                  <img v-else :src="file.url" class="media-obj" alt="img"  @error="$set(file, 'hasError', true)"/>
                </div>

                <div v-else class="h-100 w-100 d-flex align-items-center justify-content-center text-muted pl-3">
                  <font-awesome-icon icon="exclamation-circle" class="mr-2 text-danger" size="lg"/>
                  Ошибка загрузки
                </div>
              </div>
            </div>
            <b-button
              v-if="canEditLocations()"
              variant="danger"
              size="sm"
              :disabled="isDisabled"
              class="p-1 remove-btn-position rounded-circle d-flex align-items-center justify-content-center"
              @click="onRemoveFile(index)"
            >
              <font-awesome-icon icon="times-circle"/>
            </b-button>
            <b-button
              variant="info"
              size="sm"
              class="p-1 download-btn-position rounded-circle d-flex align-items-center justify-content-center"
              :href="file.url"
              :download="file.fileName"
            >
              <font-awesome-icon icon="download" style="font-size: 12px;"/>
            </b-button>
          </b-col>
        </b-row>

        <template #modal-footer="{ cancel, ok }">
          <b-button v-if="canEditLocations() && isEditing" :disabled="isDisabled" size="sm" variant="danger" @click="onRemovePassport()">
            Удалить
          </b-button>
          <b-button size="sm" variant="secondary" @click="cancel()">
            Отмена
          </b-button>
          <b-button v-if="canEditLocations()" size="sm" :disabled="isDisabled" variant="success" @click="ok()">
            <font-awesome-icon icon="save" class="mr-1" />
            Сохранить
          </b-button>
        </template>
      </b-modal>
      <b-modal
        id="modal-passport-file-view"
        v-model="showMediaViewModal"
        size="xl"
        centered
        hide-footer
        hide-header
        body-class="p-0 bg-dark"
      >
        <div class="d-flex justify-content-center align-items-center position-relative" style="min-height: 50vh;">
          <b-button
            variant="link"
            class="view-btn-position text-white position-absolute"
            @click="hideMediaView()"
          >
            <font-awesome-icon icon="times"/>
          </b-button>
          <video
            v-if="viewFile && viewFile.type.startsWith('video')"
            controls
            autoplay
            :src="viewFile.url"
            class="w-100 h-auto view-media-height"
          />
          <img
            v-else-if="viewFile"
            :src="viewFile.url"
            class="img-fluid view-media-height"
            alt="view"
          />
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";

export default {
  name: 'LocationPassport',
  mixins: [
    locations,
    helpers, permissions
  ],
  props: {
    isDisabled: Boolean,
    locationId: { type: Number, default: 0 }
  },
  data() {
    return {
      items: [],
      location_id: 0,
      locationPassport: {
        id: 0,
        location_id: 0,
        title: '',
        description: '',
        files: []
      },
      filesToDelete: [],
      isBusy: false,
      isEditing: false,
      showModalPassportFiles: false,
      showMediaViewModal: false,
      viewFile: null,
    };
  },
  beforeDestroy() {
    this.revokeAllUrls();
  },
  watch: {
    locationId: {
      handler(newValue) {
        if (newValue) {
          this.configure(newValue);
        }
      }, immediate: true
    }
  },
  methods: {
    configure(locationId) {
      this.location_id = locationId;
      this.getItems();
    },
    async getItems() {
      this.revokeAllUrls();
      this.isBusy = true;
      const result = await this.getLocationPassports(this.location_id);

      if (result.error) {
        this.showToast('Ошибка загрузки паспортов.', 'Ошибка', 'danger');
        this.isBusy = false;
        return;
      }

      const resData = result.data || [];

      this.items = resData.map(item => ({
        ...item,
        files: [],
        isLoadingFiles: true
      }));

      this.isBusy = false;

      this.items.forEach((item, index) => this.getPassportFiles(index, item.id));
    },
    async getPassportFiles(index, passportId) {
      const data = {
        id: passportId,
        location_id: this.location_id,
      }
      const listResult = await this.getLocationPassportFilesById(data);

      if (listResult.error) {
        this.$set(this.items[index], 'isLoadingFiles', false);
        return;
      }

      const filesData = listResult.data || [];

      const blobItems = await Promise.all(filesData.map(async f => {
        const contentResult = await this.getLocationPassportFiles(this.location_id, passportId, f.id);
        let objectUrl = '';
        let hasError = !!contentResult.error;
        const mimeType = f.file_type === 'photo' ? 'image/jpeg' : 'video/mp4';

        if (contentResult.error) {
          this.showError("Ошибка загрузки файла", contentResult.error.message);
        } else if (contentResult.data) {
          const blob = new Blob([contentResult.data], { type: mimeType });
          objectUrl = URL.createObjectURL(blob);
        }

        return {
          id: f.id,
          type: mimeType,
          url: objectUrl,
          isUploaded: true,
          fileName: f.file_name,
          hasError: hasError
        };
      }));

      const updatedItem = {
        ...this.items[index],
        files: blobItems,
        isLoadingFiles: false
      };
      this.$set(this.items, index, updatedItem);
    },
    onAdd() {
      if (!this.location_id) {
        this.showToast('Сначала создайте объект. Нажмите кнопку "Сохранить".', 'Ошибка добавления файла', 'danger');
        return;
      }

      this.isEditing = false;
      this.filesToDelete = [];

      this.locationPassport = {
        id: 0,
        location_id: this.location_id,
        title: '',
        description: '',
        active: true,
        files: []
      };

      if (this.$refs.passportFileInput) this.$refs.passportFileInput.reset();
      this.showModalPassportFiles = true;
    },
    onEdit(index) {
      this.isEditing = true;
      this.filesToDelete = [];
      const item = this.items[index];

      this.locationPassport = {
        id: item.id,
        location_id: item.location_id,
        title: item.title,
        description: item.description,
        active: item.active,
        files: [...item.files]
      };

      if (this.$refs.passportFileInput) this.$refs.passportFileInput.reset();
      this.showModalPassportFiles = true;
    },
    onRemoveFile(index) {
      const file = this.locationPassport.files[index];

      if (file.isUploaded && file.id) {
        this.filesToDelete.push(file.id);
      } else {
        this.revokeFileUrl(file.url);
      }

      this.locationPassport.files.splice(index, 1);
    },
    async onRemovePassport() {
      const title = 'Удаление паспорта'
      const message = `Вы уверены, что хотите удалить паспорт ${this.locationPassport.title}?`
      this.showModalDelete(title, message, async () => {
        const data = {
          id: this.locationPassport.id,
          location_id: this.location_id,
        }
        await this.deleteLocationPassport(data);
        this.hideModal();
        await this.getItems();
      });
    },
    openMediaView(file) {
      this.viewFile = file;
      this.showMediaViewModal = true;
    },
    hideMediaView() {
      this.showMediaViewModal = false;
    },
    hideModal() {
      this.showModalPassportFiles = false;
    },
    cleanUpModal() {
      this.locationPassport.files.forEach(f => {
        if (!f.isUploaded) {
          this.revokeFileUrl(f.url);
        }
      });

      this.locationPassport.files = [];
      this.filesToDelete = [];
    },
    handleUpload(v) {
      Array.from(v.target.files).forEach(file => {
        const url = URL.createObjectURL(file);

        this.locationPassport.files.push({
          fileObj: file,
          url: url,
          type: file.type,
          isUploaded: false,
          fileName: file.name,
          hasError: false
        });
      });
    },
    async handleSubmit() {
      if (!this.locationPassport.title) {
        this.showToast('Введите заголовок.', 'Ошибка сохранения паспорта', 'danger');
        return;
      }

      this.isBusy = true;

      const passportData = {
        id: this.locationPassport.id,
        location_id: this.location_id,
        title: this.locationPassport.title,
        description: this.locationPassport.description,
        active: true
      };

      let result;

      if (this.locationPassport.id === 0) {
        result = await this.postLocationPassport(passportData, this.location_id);
      } else {
        result = await this.putLocationPassport(passportData, this.location_id, this.locationPassport.id);
      }

      if (result.error) {
        this.showToast('Ошибка при сохранении.', 'Ошибка', 'danger');
        this.isBusy = false;
        return;
      }

      const passportId = (result.data && result.data.id) ? result.data.id : this.locationPassport.id;
      const dataToUpload = [];

      if (this.filesToDelete.length > 0) {
        this.filesToDelete.forEach(fileId => {
          dataToUpload.push(this.deleteLocationPassportFiles(this.location_id, passportId, fileId));
        });
      }

      const filesToUpload = this.locationPassport.files.filter(f => f.fileObj);

      if (filesToUpload.length > 0) {
        filesToUpload.forEach(fileItem => {
          const formData = new FormData();
          formData.append('file', fileItem.fileObj);
          dataToUpload.push(this.postLocationPassportFiles(this.location_id, passportId, formData));
        });
      }

      await Promise.all(dataToUpload);

      this.isBusy = false;
      this.showToast('Паспорт сохранён.', 'Успех', 'success');
      this.hideModal();
      await this.getItems();
    },
    revokeAllUrls() {
      this.items.forEach(item => {
        if (item.files) { item.files.forEach(f => this.revokeFileUrl(f.url)) }
      });

      if (this.locationPassport.files) {
        this.locationPassport.files.forEach(f => this.revokeFileUrl(f.url));
      }
    },
    revokeFileUrl(url) {
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    },
    // Permissions
    canEditLocations() {
      return this.hasPermission([PERM.LOCATION_EDIT]);
    },
  }
};
</script>

<style scoped>
.adaptive-card {
  min-width: 400px;
  flex: 1 0 400px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s, box-shadow 0.2s;
  border: 1px solid rgba(0,0,0,0.1);
}

.adaptive-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  z-index: 2;
}

.text-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 3.7rem;
}

.more-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.media-preview-row {
  height: 100px;
  width: 100%;
}

.media-preview-col {
  flex: 0 0 122px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  background-color: #f8f9fa;
}

.media-obj {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f8f9fa;
}

.modal-media-size {
  padding-top: 70%;
}

.modal-media-position {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

.remove-btn-position {
  position: absolute;
  top: -5px;
  right: 5px;
}

.download-btn-position {
  position: absolute;
  top: 23px;
  right: 5px;
}

.view-btn-position {
  top: 10px;
  right: 10px;
  z-index: 100;
  font-size: 1.5rem;
}

.view-media-height {
  max-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationPassport.vue